export enum SupplierInventoryHistoryEnum {
	Imported = 1,
	Edited = 2,
	Purchased = 3,
	Canceled = 4,
	Returned = 5,
	Added = 6,
}
